import { getDataMapper, mapArray, mapField } from "@/shared";

// Маппер для отдельного объекта
export const mapTranslationFromServer = getDataMapper({
    id: mapField("id", Number),
    updatedAt: mapField("updated_at"),
    namespace: mapField("namespace"),
    key: mapField("key"),
    combine: mapField("combine"),
    translations: mapField(
        "translations",
        getDataMapper({
            lang: mapField("lang", String),
            translation: mapField("translation", String),
            updatedAt: mapField("updated_at"),
        }),
    ),
});

// Маппер для массива
export const mapTranslationsFromServer = mapArray(mapTranslationFromServer);
